import { AsyncThunk } from '@reduxjs/toolkit';
import { ActionReducerMapBuilder } from '@reduxjs/toolkit/dist/mapBuilders';
import each from 'lodash-es/each';
import omit from 'lodash-es/omit';
import {
  PageState,
  allResourceNames,
  LikeRequest,
  Resource,
} from 'store/types';

export default (
  builder: ActionReducerMapBuilder<PageState>,
  likeRequest: AsyncThunk<
    Resource,
    LikeRequest,
    {
      rejectValue: boolean;
    }
  >
) => {
  builder.addCase(likeRequest.pending, (state, { meta }) => {
    state.isLikePending = true;
    state.pendingLikeId = meta.arg._id;
  });
  builder.addCase(likeRequest.fulfilled, (state, { meta, payload }) => {
    each(allResourceNames, (name) => {
      const item = state?.resources?.[name]?.data?.[meta.arg._id];

      if (item) {
        // TODO: можно поменять meta.arg.liked на payload.loked когда исправится баг на бэке, а можно и не менять
        item.is_liked = meta.arg.liked;
        item.likes = payload.likes;
      }
    });

    // Актуализируем понравившиеся
    if (state.resources['only_liked']) {
      if (meta.arg.liked) {
        state.resources['only_liked'].data = {
          [payload._id]: payload,
          ...state.resources['only_liked'].data,
        };
        state.resources['only_liked'].total += 1;
      } else if (state.resources['only_liked'].data[meta.arg._id]) {
        state.resources['only_liked'].data = {
          ...omit(state.resources['only_liked'].data, meta.arg._id),
        };
        state.resources['only_liked'].total -= 1;
      }
    }

    // Не забываем лайкнуть открытую карточку
    if (state.lastFetchedItem?._id === meta.arg._id) {
      state.lastFetchedItem.is_liked = meta.arg.liked;
      state.lastFetchedItem.likes = payload.likes;
    }

    state.isLikePending = false;
  });
  builder.addCase(likeRequest.rejected, (state) => {
    state.isLikePending = false;
  });
};
